export default function iframeResponsiveService($q, $window, $http) {
    let service = this,
        initializedYTList = [],
        initializedVimeoList = [],
        playerId = 0,
        regExpIsVkClip = /clip-\d+_\d+/,
        regExpVkClipId = /clip([-]?\d+)_(\d+)/,
        regExpVkId = /(?:oid=([-]?\d+)&id=(\d+))/,
        regExpIdVideo = /(youtu.*be.*)\/(watch\?v=|embed\/|v|shorts|)(.*?((?=[&#?])|$))/,
        regExpIdRutubeVideo = /(?:video|shorts|embed)\/([a-zA-Z0-9]+)/,
        regExpIframe = new RegExp('(?:<iframe[^>])'),
        regExpGetUrlFromSrc = new RegExp('(?:src=").*?(?=[?"])'),
        urlRegex = /(http[s]?:)?(\/\/)?(www\.)?[a-zA-Z0-9]+\.[^\s]{2,}/,
        loadedYouTubeIframeAPI = false,
        loadedVimeoIframeAPI = false,
        activeItem;

    service.checkInitYouTubeIframeAPI = function () {
        return loadedYouTubeIframeAPI;
    };

    service.checkInitVimeoIframeAPI = function () {
        return loadedVimeoIframeAPI;
    };

    service.checkInitVkAPI = function () {
        return loadedVimeoIframeAPI;
    };

    service.addYouTubeIframeAPI = function () {
        const tag = document.createElement('script');
        tag.src = 'https://www.youtube.com/iframe_api';
        const firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    };

    service.addVimeoIframeAPI = function () {
        const defer = $q.defer();
        initializedVimeoList.push(defer);
        const tag = document.createElement('script');
        tag.src = 'https://www.youtube.com/iframe_api';
        tag.onload = function () {
            initializedVimeoList.forEach((defer) => {
                defer.resolve();
            });
            loadedVimeoIframeAPI = true;
        };
        const firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        return defer.promise;
    };

    service.addOnYouTubeIframeAPIReady = function () {
        window.onYouTubeIframeAPIReady = function () {
            initializedYTList.forEach((defer) => {
                defer.resolve();
            });
            loadedYouTubeIframeAPI = true;
        };
        const defer = $q.defer();
        initializedYTList.push(defer);
        if (!service.checkInitYouTubeIframeAPI()) {
            service.addYouTubeIframeAPI();
        }
        return defer.promise;
    };

    service.getPlayerId = function () {
        return `player${(playerId += 1)}`;
    };

    service.getVideoIdFromYouTube = function (url) {
        return url.match(regExpIdVideo)[3];
    };

    service.getVideoIdFromVimeo = function (url) {
        const regexp =
            /(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^\/]*)\/videos\/|album\/(?:\d+)\/video\/|video\/|)(\d+)(?:[a-zA-Z0-9_\-]+)?/i;
        return url.match(regexp)[1];
    };

    service.getYTPlayerAPI = function (elId, videoId, callbacks, autoplay, loop) {
        /* eslint-disable no-undef */
        return new YT.Player(elId, {
            videoId,
            playerVars: {
                enablejsapi: 1,
                html5: 1,
                fmt: 1,
                showinfo: 0,
            },
            events: callbacks,
        });
    };

    service.getVimeoPlayerAPI = function (elId, videoId, autoplay, loop) {
        /* eslint-disable no-undef */
        return new Vimeo.Player(elId, {
            id: videoId,
            autoplay: autoplay != null ? autoplay : false,
            muted: autoplay != null ? autoplay : false,
            loop: loop === true,
        });
    };

    service.pausePlayer = function (obj, type) {
        if (obj == null || obj.player == null) {
            return;
        }

        try {
            if (type === 'youtube') {
                obj.player.pauseVideo();
            } else {
                obj.player.pause();
            }
        } catch {
            // плеер мог быть ещё не готов или уже уничтожен
        }

        if (activeItem != null && activeItem.obj === obj) {
            activeItem = null;
        }
    };

    service.run = function (obj, type) {
        if (activeItem != null && activeItem.obj !== obj) {
            service.pausePlayer(activeItem.obj, activeItem.type);
        }

        activeItem = {
            obj,
            type,
        };
    };

    service.checkUrlFromIframe = function (url) {
        return url.match(regExpIframe);
    };

    service.getSrc = function (url) {
        if (service.checkUrlFromIframe(url)) {
            return url.match(regExpGetUrlFromSrc)[0].match(urlRegex)[0];
        }
        return url;
    };

    service.isPlayerCode = function (url) {
        return url.match(urlRegex) == null;
    };

    // параметры, которые проставляет сам плеер: из исходной ссылки их не переносим
    const youtubeOwnParams = ['v', 'rel', 'enablejsapi', 'showinfo', 'autoplay', 'mute', 'loop', 'controls', 'wmode', 'playlist'];

    service.normalizeUrl = function (link) {
        if (link.indexOf('//') === 0) {
            return `https:${link}`;
        }
        if (/^https?:\/\//iu.test(link) === false) {
            return `https://${link}`;
        }
        return link;
    };

    // id достаём из самой ссылки: watch?v=<id>, youtu.be/<id>, embed/<id>, shorts/<id>, v/<id>
    const getYouTubeIdFromUrl = function (url) {
        const fromQuery = url.searchParams.get('v');
        if (fromQuery) {
            return fromQuery;
        }
        const segments = url.pathname.split('/').filter((segment) => segment.length > 0);
        return segments.length > 0 ? segments[segments.length - 1] : null;
    };

    service.getYouTubeCode = function (link, autoplay, videoId, loop) {
        let source;
        try {
            source = new URL(service.normalizeUrl(link));
        } catch {
            return link;
        }

        const id = getYouTubeIdFromUrl(source) || videoId;
        const target = new URL(id != null ? `https://www.youtube.com/embed/${id}` : `${source.origin}${source.pathname}`);

        // пользовательские параметры исходной ссылки (start, list и прочее) сохраняем
        source.searchParams.forEach((value, key) => {
            if (youtubeOwnParams.includes(key) === false) {
                target.searchParams.set(key, value);
            }
        });

        target.searchParams.set('rel', '0');
        target.searchParams.set('enablejsapi', '1');
        target.searchParams.set('showinfo', '0');

        if (autoplay || loop) {
            target.searchParams.set('autoplay', '1');
            target.searchParams.set('mute', '1');
        }

        if (loop) {
            target.searchParams.set('loop', '1');
            target.searchParams.set('controls', '0');
            target.searchParams.set('wmode', 'transparent');
            target.searchParams.set('playlist', videoId || id || '');
        }

        return target.toString();
    };

    service.getVimeoCode = function (link, autoplay, loop) {
        return `https://player.vimeo.com/video${link.split('vimeo.com')[link.split('vimeo.com').length - 1]}?title=0&amp;byline=0&amp;portrait=0${
            autoplay ? '&autoplay=1&muted=1' : ''
        }${loop ? '&loop=1' : ''}`;
    };

    service.getYTCover = function (YTVideoId) {
        return `https://i.ytimg.com/vi_webp/${YTVideoId}/maxresdefault.webp`;
    };

    service.getVimeoCover = function (vimeoId) {
        return $http
            .get(`https://vimeo.com/api/oembed.json?url=https%3A//vimeo.com/${vimeoId}`, {
                format: 'json',
                width: '1280',
            })
            .then((response) => response)
            .catch((error) => {
                console.error(error);
            });
    };

    /// #region Rutube
    // https://github.com/rutube/RutubePlayerJSAPI
    // https://github.com/evikza/rutube-player/blob/main/rt.js

    service.getVideoIdFromRutube = function (url) {
        const match = url.match(regExpIdRutubeVideo);
        return match && match[1];
    };

    service.getRutubeCode = function (link, autoplay, loop) {
        const videoId = service.getVideoIdFromRutube(link);
        return `https://rutube.ru/play/embed/${videoId}?autoplay=${autoplay ? '1' : '0'}`;
    };

    const Rutube = function () {
        this.Player = function (id, config) {
            this.selector = id;
            this.config = config;
        };

        this.getId = function () {
            return this.selector;
        };

        this.triggerEventObserver = function (env, args = null) {
            if (!this.config.events || !this.config.events[env]) return;

            return this.config.events[env](args);
        };

        this.setPlayerState = function (status) {
            const playerState = {
                playerState: { PLAYING: 0, PAUSED: 0, STOPPED: 0, PREROLL: 0 },
            };

            for (const state in playerState.playerState) {
                if (state.toLowerCase() === status.toLowerCase()) {
                    playerState.playerState[state] = 1;

                    break;
                }
            }

            return playerState;
        };

        for (const [iterator, type] of Object.entries({
            play: 'play',
            pause: 'pause',
            stop: 'stop',
            seekTo: 'setCurrentTime',
            changeVideo: 'changeVideo',
            mute: 'mute',
            unMute: 'unMute',
            setVolume: 'setVolume',
        })) {
            this[iterator] = function (data = {}) {
                document.getElementById(this.selector).contentWindow.postMessage(
                    JSON.stringify({
                        type: `player:${type}`,
                        data,
                    }),
                    '*',
                );
            };
        }

        this.playerEvent = function (receivedMessage) {
            switch (receivedMessage.type) {
                case 'player:ready':
                    this.triggerEventObserver('onReady');
                    break;

                case 'player:changeState':
                    this.triggerEventObserver('onStateChange', this.setPlayerState(receivedMessage.data.state));
                    break;

                case 'player:rollState': // реклама
                    this.triggerEventObserver('onStateChange', this.setPlayerState('preroll'));
                    break;

                case 'player:playComplete':
                    this.triggerEventObserver('onComplete');
                    break;
            }
        };

        window.addEventListener(
            'message',
            (event) => {
                const receivedMessage = JSON.parse(event.data);
                this.playerEvent(receivedMessage);
            },
            0,
        );
    };

    service.getRutubePlayer = function (playerId, events) {
        const rt = new Rutube();
        rt.Player(playerId, events);
        return rt;
    };

    // #endregion

    service.getVideoIdsFromVk = function (url) {
        const isClip = service.checkIsVkClip(url);
        const ids = url.match(isClip ? regExpVkClipId : regExpVkId);

        if (ids.length) {
            return ids.slice(1);
        }
    };

    service.checkIsVkClip = function (url) {
        return regExpIsVkClip.test(url);
    };

    service.addVkAPI = function () {
        return new Promise((resolve) => {
            if (!service.checkInitVkAPI()) {
                const tag = document.createElement('script');
                tag.src = 'https://vk.ru/js/api/videoplayer.js';
                const firstScriptTag = document.getElementsByTagName('script')[0];
                firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
                tag.onload = () => {
                    resolve();
                };
            } else {
                resolve();
            }
        });
    };

    service.getVkPlayer = function (iframe) {
        return VK?.VideoPlayer(iframe);
    };
}

iframeResponsiveService.$inject = ['$q', '$window', '$http'];
